import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-core-react';

export enum RoutesIds {
  issues = 'issues',
  issue = 'issue',
  themes = 'themes',
}

enum ExternalRoutesIds {
  chat = 'chat',
}

export const issuesRouteRef = createPageRoute({
  id: 'issue-index',
  page: { title: 'Issues' },
});

export const rootRouteRef = issuesRouteRef;

export const issueRouteRef = createPageRoute({
  id: RoutesIds.issue,
  route: { path: '/:id', parent: rootRouteRef },
  page: { title: 'Issue' },
});

export const themesRouteRef = createRouteRef({
  id: RoutesIds.themes,
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const Routes = {
  issues: issuesRouteRef,
  issue: issueRouteRef,
  themes: themesRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  chat: chatRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
